module.exports = __webpack_public_path__ + "img/4.25593fc1.jpg";